export default "__VITE_ASSET__BwpvNLD2__"